export default "__VITE_ASSET__BB15XAE7__"